import React from 'react';
import styled from 'styled-components';
import {useIntl} from 'react-intl';
import {DropdownHandler, NavBarIconButton} from '@forecast-it/design-system';
import * as tracking from '../../../tracking';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {MODAL_TYPE, showModal} from '../../shared/components/modals/generic_modal_conductor';
import ShortcutModalContent from '../../shared/components/modals/navigation/ShortcutsModal';
import {hasModule} from '../../shared/util/ModuleUtil';
import {MODULE_TYPES} from '../../../constants';

const StyledA = styled.a`
	text-decoration: none;
	&:hover {
		color: inherit;
	}
`;

const HelpButton = props => {
	const intl = useIntl();
	const showWhatIsNewModal = () => {
		tracking.trackElementClicked('whats new');
		trackEvent('Whats New', 'Clicked');
		showModal({
			type: MODAL_TYPE.WHAT_IS_NEW,
		});
	};
	const showShortcutModal = () => {
		trackEvent('Navigation Bar Help Menu Shortcuts', 'Clicked');
		const {formatMessage} = intl;

		showModal({
			type: MODAL_TYPE.GENERIC,
			headerText: formatMessage({id: 'header.shortcuts'}),
			content: <ShortcutModalContent />,
		});
	};
	return (
		<DropdownHandler>
			<DropdownHandler.Trigger onClick={() => trackEvent('Navigation Bar Help Menu Button', 'Clicked')}>
				<NavBarIconButton aria-label="help" icon="help" />
			</DropdownHandler.Trigger>
			<DropdownHandler.Content>
				<DropdownHandler.Item onClick={showShortcutModal}>Shortcuts</DropdownHandler.Item>
				<DropdownHandler.Item onClick={showWhatIsNewModal}>What's New</DropdownHandler.Item>
				{!hasModule(MODULE_TYPES.SAGE_INTACCT_RESTRICTED) ? (
					<DropdownHandler.Item asChild>
						<StyledA
							href="https://support.forecast.app"
							target="_blank"
							rel="noopener noreferrer"
							onClick={() => trackEvent('Help Center', 'Opened')}
						>
							Help
						</StyledA>
					</DropdownHandler.Item>
				) : null}
			</DropdownHandler.Content>
		</DropdownHandler>
	);
};

export default HelpButton;
